import React, { Component } from 'react'

export default class Introduction extends Component {
  render() {
    return (
      <div>
        <section id="colorlib-hero" className="js-fullheight" data-section="home">
          <div className="flexslider js-fullheight">
            <ul className="slides">
              <li style={{backgroundImage: 'url(https://media.giphy.com/media/3o7ZerdezTT72sWC1W/giphy.gif)'}}>
                <div className="overlay" />
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                      <div className="slider-text-inner js-fullheight">
                        <div className="desc">
                          <h1 style={{ color: 'white' }}>Hi! <br />I'M OMKAR DHARKAR</h1>
                          <p><a className="btn btn-primary btn-learn" style={{ color: 'white' }} href="https://www.linkedin.com/in/omkar-dharkar-23002b17a/" target="_blank" rel="noopener noreferrer">View CV<i className="icon-download4" /></a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li style={{backgroundImage: 'url(https://media.giphy.com/media/3o7ZerdezTT72sWC1W/giphy.gif)'}}>
                <div className="overlay" />
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                      <div className="slider-text-inner">
                        <div className="desc">
                          <h1 style={{ color: 'white' }}>I AM PASSIONATE ABOUT BUILDING<br /> THINGS !!</h1>
                          <p><a className="btn btn-primary btn-learn" style={{ color: 'white' }} href="https://github.com/grasperIQ100" target="_blank" rel="noopener noreferrer">View Projects <i className="icon-briefcase3" /></a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section>
      </div>
    )
  }
}
